module.exports = __webpack_public_path__ + "static/media/history_dat.d8bdf6a7.png";